import { UserPrefs } from '@/lib/prefs'

export default ({ app }, inject) => {
  // Inject $prefs in Vue, context and store.
  let prefs = new UserPrefs(app.store)
  inject('prefs', prefs)
}
